import { useEffect } from 'react';

function useSyncPersistStore(store, value) {
  useEffect(() => {
    if (store.persistStore?.value !== value) {
      if (store.persistStore?.value) {
        if (!store.persistStore.typeAssertion(store.persistStore.value)) {
          // eslint-disable-next-line no-console
          console.warn('Persisted value is not matched with the type assertion.');
          return;
        }
        const persistValue = store.persistStore.value;
        store.set(() => persistValue);
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}

export { useSyncPersistStore };
